import { useState } from "react";
import * as styles from "./AddressNode.styles";
import { CircularSpinner } from "./CircularSpinner";
import { LogEntryRow } from "./LogEntryRow";
import { ProviderNode } from "./ProviderNode";
import { StatusBadge } from "./StatusBadge";
import type { AddressNodeProps } from "./types";

const AddressNode = ({ addressName, status, label, entries, providers }: AddressNodeProps) => {
  const [open, setOpen] = useState(true);
  const hasProviders = !!providers.length;
  const hasEntries = !!entries?.length;

  return (
    <div className={styles.card}>
      <button onClick={() => setOpen((o) => !o)} disabled={!hasProviders && !hasEntries} className={styles.headerButton}>
        <span className={styles.expandIcon}>{(hasProviders || hasEntries) && (open ? "▾" : "▸")}</span>
        <CircularSpinner status={status} size={16} />
        <span className={styles.addressName}>{addressName}</span>
        <StatusBadge status={status} label={label} />
        <span className={styles.collapseIcon}>{open ? "▲" : "▼"}</span>
      </button>
      {(open || hasProviders) && (
        <div className={styles.body}>
          {hasEntries && entries?.map((entry, idx) => <LogEntryRow key={entry.id ?? `${entry.timestamp}-${idx}`} entry={entry} />)}
          {hasProviders &&
            providers.map((provider) => (
              <ProviderNode
                key={provider.id}
                providerName={provider.name}
                status={provider.status}
                label={provider.label}
                entries={provider.entries}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export { AddressNode };
